export default __webpack_public_path__ + "static/media/ok_check.d722451a.png";